import React, { useEffect, useState } from "react";
import { object } from "prop-types";
import { useDispatch } from "react-redux";

import { getLoadMoreStories } from "../../utils";
import List from "../../rows/list";
import { getSearchPageItems } from "../../../../api/utils";
import ScrollToTop from "../../atoms/back-to-top-button";

const SearchPage = (props) => {
  // will be getting initially 9 stories, but showing only 8 for loadmore functionality

  const [storiesToRender, setStoriesToRender] = useState(8);
  const [stories, setStories] = useState(props.data.stories);
  const [sortType, setSortType] = useState("score");
  const [params, setparams] = useState("");

  const dispatch = useDispatch();

  const setLoading = (isloading) => {
    dispatch(isloading ? { type: "QT-PAGE_LOADING" } : { type: "QT-PAGE_FINISHED_LOADING" });
  };

  const getMoreStories = async () => {
    setLoading(true);
    await getLoadMoreStories({
      offset: storiesToRender,
      limit: 4,
      isSearchPage: true,
      slug: props.data.query,
      setStories: setStories,
      storiesToRender: storiesToRender,
      setStoriesToRender: setStoriesToRender,
      stories: stories,
      sortBy: sortType,
      params: params,
    });
    setLoading(false);
  };

  const updateStories = async () => {
    const stories = await getSearchPageItems(props.data.query, 0, 9, sortType, params);

    setStories(stories);
  };

  useEffect(() => {
    updateStories();
  }, [params, sortType]);

  return (
    <div className="container">
      <List
        stories={stories.slice(0, storiesToRender)}
        showLoadmore={stories.length > storiesToRender}
        loadMoreStories={getMoreStories}
        query={props.data.query}
        updateStories={updateStories}
        sections={props.config.sections}
        setparams={setparams}
        setSortType={setSortType}
      />
      <ScrollToTop />
    </div>
  );
};

SearchPage.propTypes = {
  data: object,
  config: object,
};

export { SearchPage };
